import React, { Component } from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'
import { RIEInput } from 'riek'
import { Droppable } from 'react-beautiful-dnd'

import { capitalize, getStageElementsByTypes } from '../../functions'

import MemberItems from './member-items'

class Input extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.value !== this.props.value) return true
    if (nextProps.propName !== this.props.propName) return true
    if (nextProps.className !== this.props.className) return true
    if (nextState !== this.state) return true
    return false
  }

  render() {
    const { value, propName, className } = this.props

    return (
      <RIEInput
        value={value}
        propName={propName}
        className={className}
        classEditing="riek-editing"
        change={(propValue) => this.props.change(propValue)} />
    )
  }
}

class Member extends Component {
  constructor(props) {
    super(props)

    this.state = {
      name: '',
      email: '',
      phone: '',
      showDropdown: false,
      focus: false,
      error: ''
    }

    this.input = React.createRef()
  }

  componentWillMount() {
    const { member } = this.props
    const { name, email, phone } = member

    this.setState({name, email, phone})
  }

  componentDidMount() {
    const { member } = this.props

    if (member.id === undefined) this.input.current.startEditing()
  }

  componentWillReceiveProps(nextProps) {
    const { member } = nextProps

    if (member !== this.props.member) {
      const { name, email, phone } = member

      this.setState({name, email, phone})
    }
  }

  memberIsUpdated(updatedItems = undefined) {
    const { id } = this.props.member
    let { items } = this.props.member
    const { name, email, phone } = this.state

    const itemIds = []
    items = updatedItems !== undefined ? updatedItems : items
    items.map(item => itemIds.push(item.id))

    if (id) {
      this.props.editRiderMember({id, name, email, phone, items: itemIds})
    } else {
      this.props.createRiderMember({name, email, phone, items: itemIds})
    }
  }

  renderDropdown(member) {
    const { showDropdown } = this.state

    const className = classnames({
      'ui-dropdown': true,
      'ui-dropdown--active': showDropdown
    })

    return (
      <div className={className}>
        {showDropdown === true ? <div className="ui-dropdown-escape" onClick={() => this.setState({showDropdown: !showDropdown})} /> : null}

        <div className="ui-dropdown-handle" onClick={() => this.setState({showDropdown: !showDropdown})} />

        {
          showDropdown === true
          ? <ul className="ui-dropdown-content">
              {/*<li onClick={() => this.setState({showDropdown: false}, () => this.props.moveRiderMember({id: member.id, position: 2}))}>Reposition to 2</li>*/}
              <li onClick={() => this.setState({showDropdown: false}, () => this.props.deleteRiderMember(member))}>Remove this member</li>
            </ul>
          : null
        }
      </div>
    )
  }

  renderMember() {
    const { view, member, position, isDragging, stageElements } = this.props
    // const { name, email, phone, showDropdown, focus, error } = this.state
    const { name, phone, showDropdown, focus, error } = this.state

    const className = classnames({
      'card': true,
      'card--focus': showDropdown || focus,
      'member': true
    })

    const nameClassName = classnames({
      'riek': true,
      'name': true,
      'h4': true,
      'placeholder': !name
    })

    // const emailClassName = classnames({
    //   'riek': true,
    //   'email': true,
    //   'placeholder': !email
    // })

    const phoneClassName = classnames({
      'riek': true,
      'phone': true,
      'placeholder': !phone
    })

    const droppableClassName = isDraggingOver => classnames({
      'member--droppable': true,
      'member--droppable-dragging': isDragging,
      'member--droppable-dragging-over': isDraggingOver
    })

    return (
      <li className={className}>
        <div className="card-content" data-number={position} data-error={error}>
          {
            view.editable
            ? this.renderDropdown(member)
            : null
          }

          <Droppable droppableId={member.id} isDropDisabled={!view.editable} type="member-items">
            {(provided, snapshot) => (
              <div className={droppableClassName(snapshot.isDraggingOver)} ref={provided.innerRef}>
                {
                  view.editable
                  ? <Input
                      value={name || ''}
                      propName="name"
                      className={nameClassName}
                      change={({name}) => {
                        name
                        ? this.setState({name}, () => this.memberIsUpdated())
                        : this.setState({name: member.name})
                      }} />
                  : <div className={nameClassName}>{name}</div>
                }

                <label className="enter">Enter</label>

                <MemberItems
                  view={view}
                  items={member.items}
                  setFocus={(state) => this.setState({focus: state})}
                  createRiderItem={(item) => {
                    this.props.createRiderItem({...item, member: member.id})
                    this.props.setAlert({message: `We have added "${item.title}" to input list and assigned it to ${member.name}.`})
                  }}
                  updateMember={(items) => this.memberIsUpdated(items)}
                  availableItems={this.props.availableItems}
                  options={
                    stageElements.instrument
                    ? stageElements.groups && stageElements.groups.instrument && stageElements.groups.instrument.children // categories
                      ? [...stageElements.instrument, ...stageElements.groups.instrument.children]
                      : getStageElementsByTypes(['instrument'], stageElements)
                    : undefined
                  }
                  categories={getStageElementsByTypes(['children'], stageElements && stageElements.groups && stageElements.groups.instrument)}
                  searchResults={this.props.searchResults}
                  getSearchResults={this.props.getSearchResults} />

                {/*<Input
                  value={email || 'Email - click to add'}
                  propName="email"
                  className={emailClassName}
                  change={({email}) => this.setState({email}, () => this.memberIsUpdated())} />*/}

                {
                  view.editable
                  ? <Input
                      value={phone || 'Add a phone number'}
                      propName="phone"
                      className={phoneClassName}
                      change={({phone}) => this.setState({phone}, () => this.memberIsUpdated())} />
                  : <div className={phoneClassName}>{phone}</div>
                }

                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </div>
      </li>
    )
  }

  renderEmptyMember() {
    const { view, position } = this.props
    const { name, error } = this.state

    const className = classnames({
      'card': true,
      'card--focus': true
    })

    if (view.editable !== true) return null

    return (
      <li className={className}>
        <div className="card-escape" onClick={() => this.props.removeRiderMember(position-1)} />

        <div className="card-content" data-number={position} data-error={error} tabIndex="0"
          onKeyDown={(e) =>
            e.key === 'Enter'
            ? setTimeout(() => {
                const { name } = this.state

                this.setState({
                  error:
                    !name
                    ? 'Please insert a name'
                    : null
                }, () => {
                  name
                  ? this.memberIsUpdated()
                  : this.input.current.startEditing()
                })
              }, 1) // add setTimeout as change and onKeyDown are fired asynchronously
            : e.key === 'Escape'
              ? this.props.removeRiderMember(position-1)
              : null
          }>
          <div className="riek-escape" onClick={() => this.props.removeRiderMember(position-1)} />

          <RIEInput
            ref={this.input}
            value={name || ''}
            propName="name"
            className="riek riek-editing name h4"
            change={({name}) => this.setState({name: capitalize(name)})} />

          <label className="enter" onClick={() => {
            this.setState({
              error:
                !name
                ? 'Please insert a name'
                : null
            }, () => {
              name
              ? this.memberIsUpdated()
              : this.input.current.startEditing()
            })
          }}>Enter</label>
          <div className="remove-member" onClick={() => this.props.removeRiderMember(position-1)} />

          <p>Add new band member</p>
        </div>
      </li>
    )
  }

  render() {
    const { member } = this.props

    return member.id !== undefined
    ? this.renderMember()
    : this.renderEmptyMember()
  }
}

Member.propTypes = {
  view: PropTypes.object,
  member: PropTypes.object,
  position: PropTypes.number,
  isDragging: PropTypes.bool,
  createRiderItem: PropTypes.func,
  removeRiderMember: PropTypes.func,
  createRiderMember: PropTypes.func,
  editRiderMember: PropTypes.func,
  moveRiderMember: PropTypes.func,
  deleteRiderMember: PropTypes.func,
  availableItems: PropTypes.array,
  stageElements: PropTypes.object,
  searchResults: PropTypes.array,
  getSearchResults: PropTypes.func,
  setAlert: PropTypes.func
}

Member.defaultProps = {
  view: {},
  member: {},
  position: 0,
  isDragging: false,
  createRiderItem: function() {},
  removeRiderMember: function() {},
  createRiderMember: function() {},
  editRiderMember: function() {},
  moveRiderMember: function() {},
  deleteRiderMember: function() {},
  availableItems: [],
  stageElements: {},
  searchResults: undefined,
  getSearchResults: function() {},
  setAlert: function() {}
}

export default Member



// WEBPACK FOOTER //
// ./src/components/rider/rider-members/member.js